import { render, staticRenderFns } from "./applyAdList.vue?vue&type=template&id=1f97ec2f&scoped=true&"
import script from "./applyAdList.vue?vue&type=script&lang=js&"
export * from "./applyAdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97ec2f",
  null
  
)

export default component.exports